/**
 * sc-3031 — ResetPaymentPlanButton
 *
 * Dashed Button mit rotem Rand + roter Schrift, platziert links neben den
 * "Rabatt hinzufügen"/"Guthaben verrechnen"-Buttons in der Posten-Sektion
 * (PanelCardPayments). Öffnet den ResetPaymentPlanModal-Dialog.
 *
 * Sichtbar nur, wenn:
 *   - Buchung ist abgerechnet (`booking.invoice?.id`)
 *   - Buchung ist nicht canceled
 *   - Kurs erlaubt Einzelbuchungen (`course.allowLessonBooking`)
 */
import React, {FC, useState} from "react";
import {Button, Tooltip} from "antd";
import {ReloadOutlined} from "@ant-design/icons";
import i18n from "../../../services/i18n";
import {GetBookingByIdQuery, GetBookingByIdWithCourseLessonBookingsQuery} from "../../../generated/graphql";
import ResetPaymentPlanModal from "./ResetPaymentPlanModal";
import css from "./ResetPaymentPlanButton.less";

type BookingData = GetBookingByIdQuery["bookingById"] | GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"];

type ResetPaymentPlanButtonProps = {
    booking?: BookingData;
    refetch: () => void;
};

const ResetPaymentPlanButton: FC<ResetPaymentPlanButtonProps> = ({booking, refetch}) => {
    const [open, setOpen] = useState(false);

    if (!booking || !booking.id) {
        return null;
    }

    const isCanceled = booking.canceled !== null && booking.canceled !== undefined;
    const hasInvoice = Boolean(booking.invoice?.id);
    const allowLessonBooking = Boolean(booking.courseLessons?.[0]?.course?.allowLessonBooking);

    if (!hasInvoice || isCanceled || !allowLessonBooking) {
        return null;
    }

    return (
        <>
            <Tooltip title={i18n.containers.invoice.SettlementDetails.moreMenu.resetPaymentPlanTooltip()} placement="top">
                <Button block type="text" size="small" icon={<ReloadOutlined style={{marginRight: -3}} />} className={css.dangerDashedButton} onClick={() => setOpen(true)}>
                    {i18n.containers.invoice.SettlementDetails.moreMenu.resetPaymentPlanToCourseStandard()}
                </Button>
            </Tooltip>
            {open && <ResetPaymentPlanModal open={open} bookingId={booking.id} onClose={() => setOpen(false)} onSuccess={refetch} />}
        </>
    );
};

export default ResetPaymentPlanButton;
